class PersonalizeSchedule {
    schedule: Element;
    slides: Element[];
    progressBars: Element[];
    continueButton: Element | null;
    buttons: Element[];
    goToScheduleButton: Element | null;
    selectedParentFormats: Array<string>;
    selectedTracks: Array<string>;

    constructor(schedule: Element) {
        this.schedule = schedule;

        this.slides = Array.from(schedule.querySelectorAll('.slide'));
        this.progressBars = Array.from(schedule.querySelectorAll('.progress-bar-schedule'));
        this.continueButton = schedule.querySelector('.continue-button');
        this.goToScheduleButton = schedule.querySelector('.go-to-button');
        this.buttons = Array.from(schedule.querySelectorAll('.buttons .btn-wrapper'));

        this.selectedTracks = [];
        const selectedModules: Array<string> = [];
        const selectedFormats: Array<string> = [];
        this.selectedParentFormats = [];
        let acitveSlide = 0;

        // set first slide and progress bar to active
        this.slides[0].classList.add('active');
        this.progressBars[0].classList.add('active');
        this.buttons[1].classList.add('hidden');

        const formatButtons = this.schedule.querySelectorAll('.format');

        formatButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const format = (button as HTMLElement).dataset.id;
                if (!format) return;

                if (selectedFormats.includes(format)) {
                    selectedFormats.splice(selectedFormats.indexOf(format), 1);
                    button.classList.remove('active');
                } else {
                    selectedFormats.push(format);
                    button.classList.add('active');
                }

                if (this.goToScheduleButton) {
                    const url = new URL((this.goToScheduleButton as HTMLAnchorElement).href);
                    url.searchParams.set('types', selectedFormats.join(','));

                    (this.goToScheduleButton as HTMLAnchorElement).href = url.toString();
                }
            });
        });

        const parentformatButtons = this.schedule.querySelectorAll('.parentformat');

        parentformatButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const format = (button as HTMLElement).dataset.id;
                if (!format) return;

                if (this.selectedParentFormats.includes(format)) {
                    this.selectedParentFormats.splice(this.selectedParentFormats.indexOf(format), 1);
                    this.buttons[1].classList.add('hidden');
                    this.buttons[0].classList.remove('hidden');
                    button.classList.remove('active');
                } else {
                    this.selectedParentFormats.push(format);
                    this.buttons[0].classList.add('hidden');
                    this.buttons[1].classList.remove('hidden');
                    button.classList.add('active');
                }

                if (this.goToScheduleButton) {
                    const url = new URL((this.goToScheduleButton as HTMLAnchorElement).href);
                    url.searchParams.set('parentformatids', this.selectedParentFormats.join(','));

                    (this.goToScheduleButton as HTMLAnchorElement).href = url.toString();
                }

                this.checkIfGoToScheduleButtonVisible();
            });
        });

        const trackButtons = this.schedule.querySelectorAll('.track');

        trackButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const trackId = (button as HTMLElement).dataset.id;
                if (!trackId) return;

                if (this.selectedTracks.includes(trackId)) {
                    this.selectedTracks.splice(this.selectedTracks.indexOf(trackId), 1);
                    button.classList.remove('active');
                } else {
                    this.selectedTracks.push(trackId);
                    button.classList.add('active');
                }

                if (this.goToScheduleButton) {
                    const url = new URL((this.goToScheduleButton as HTMLAnchorElement).href);
                    url.searchParams.set('trackids', this.selectedTracks.join(','));

                    (this.goToScheduleButton as HTMLAnchorElement).href = url.toString();
                }

                this.checkIfGoToScheduleButtonVisible();
            });
        });

        const moduleButtons = this.schedule.querySelectorAll('.module');

        moduleButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const moduleId = (button as HTMLElement).dataset.id;
                if (!moduleId) return;

                if (selectedModules.includes(moduleId)) {
                    selectedModules.splice(selectedModules.indexOf(moduleId), 1);
                    button.classList.remove('active');
                } else {
                    selectedModules.push(moduleId);
                    button.classList.add('active');
                }

                if (this.goToScheduleButton) {
                    const url = new URL((this.goToScheduleButton as HTMLAnchorElement).href);
                    url.searchParams.set('moduleids', selectedModules.join(','));

                    (this.goToScheduleButton as HTMLAnchorElement).href = url.toString();
                }
            });
        });

        this.continueButton?.addEventListener('click', () => {
            acitveSlide++;
            this.slides[acitveSlide].classList.add('active');
            this.slides[acitveSlide - 1].classList.remove('active');
            this.progressBars[acitveSlide].classList.add('active');

            if (acitveSlide === this.slides.length - 1) {
                this.buttons[0].classList.add('hidden');
                this.buttons[1].classList.remove('hidden');
            }
        });
    }

    checkIfGoToScheduleButtonVisible() {
        if (this.selectedTracks.length === 0 && this.selectedParentFormats.length > 0) {
            this.buttons[0].classList.add('hidden');
            this.buttons[1].classList.remove('hidden');
        } else {
            this.buttons[0].classList.remove('hidden');
            this.buttons[1].classList.add('hidden');
        }
    }
}

export default {
    init() {
        const schedule = document.querySelectorAll('.personilized-schedule') as NodeListOf<Element>;

        if (!schedule.length) {
            return;
        }

        schedule.forEach((schedule) => {
            new PersonalizeSchedule(schedule);
        });
    }
};
